import { render, staticRenderFns } from "./HospitalizationReport.vue?vue&type=template&id=1a6fc4b2&scoped=true&"
import script from "./HospitalizationReport.vue?vue&type=script&lang=js&"
export * from "./HospitalizationReport.vue?vue&type=script&lang=js&"
import style0 from "./HospitalizationReport.vue?vue&type=style&index=0&id=1a6fc4b2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a6fc4b2",
  null
  
)

export default component.exports